import type { IssueTypeProperties } from './issue-type-properties.tsx';

export type ExtraDefinerId = number;
export type RequestTypeId = number;

export const IssueLayoutIssueTypeOwnerType = 'ISSUE_TYPE' as const;
export const IssueLayoutRequestTypeOwnerType = 'REQUEST_TYPE' as const;
export type IssueLayoutOwnerType =
	| typeof IssueLayoutIssueTypeOwnerType
	| typeof IssueLayoutRequestTypeOwnerType;

export type IssueLayoutIssueTypeOwner = {
	type: typeof IssueLayoutIssueTypeOwnerType;
	data: {
		id: number;
		name: string;
		description: string;
		avatarId: string | null;
		iconUrl: string | null;
		properties?: IssueTypeProperties;
	};
};

export type IssueLayoutRequestTypeOwner = {
	type: typeof IssueLayoutRequestTypeOwnerType;
	data: {
		id: RequestTypeId;
		externalUuid: string;
		name: string;
		description: string;
		instructions: string;
		avatarId: string | null;
		iconUrl: string | null;
		restrictionStatus: 'OPEN' | 'RESTRICTED';
		properties: IssueTypeProperties;
	};
};

export type IssueLayoutOwner = IssueLayoutRequestTypeOwner | IssueLayoutIssueTypeOwner;
